 <template>
    <div class="chequeosStatusBar">
        <strong>Último chequeo: </strong>
        <span class="ultimoChequeoHora">{{ ultimoChequeoHora }}</span>
        <ProgressSpinner class="chequeandoSpinner" strokeWidth="8" fill="#eee" animationDuration="1.5s" v-if="chequeando" />
        <span class="chequeandoAviso" v-if="chequeando">Chequeando ...</span>
    </div>
    <div class="p-grid p-fluid dashboard">
        <div class="p-col-12 p-lg-4">
            <div class="card summary">
                <span class="title link" @click="$router.push({ name: 'cliente_documentacion' })">Documentación</span>
                <span class="detail ellipsis" v-html="documentacionStatus"></span>
                <span class="count" :class="documentacionCompleta ? 'visitors' : 'danger'">{{ documentacion }}</span>
            </div>
        </div>
        <div class="p-col-12 p-lg-4">
            <div class="card summary">
                <span class="title link" @click="$router.push({ name: 'cliente_usuarios_admin' })">Usuarios Activos</span>
                <span class="detail ellipsis">Toda la documentación al día.</span>
                <span class="count visitors">
                    {{ usuariosActivos }}
                    <ProgressSpinner class="cargandoSpinner" strokeWidth="8" animationDuration="1.5s" v-if="usuarios === null" />
                </span>
            </div>
        </div>
        <div class="p-col-12 p-lg-4">
            <div class="card summary">
                <span class="title link" @click="$router.push({ name: 'cliente_usuarios_admin' })">Usuarios Deshabilitados</span>
                <span class="detail ellipsis">Tienen documentación pendiente.</span>
                <span class="count danger">
                    {{ usuariosInactivos }}
                    <ProgressSpinner class="cargandoSpinner" strokeWidth="8" animationDuration="1.5s" v-if="usuarios === null" />
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UsuariosService from '../../service/UsuariosService'
import moment from 'moment'

export default {
    name: "InicioClientes",
    data() {
        return {
            chequeoTimer: null,
            chequeando: false,
            ultimoChequeoHora: '-',
            usuarios: null,
            usuariosActivos: 0,
            usuariosInactivos: 0,
        }
    },
    async mounted() {
        this.procesarStats()
        this.chequeoTimer = setInterval(() => {
            this.procesarStats()
        }, 30000)
    },
    unmounted() {
        clearInterval(this.chequeoTimer)
    },
    computed: {
        ...mapGetters('auth', ['usuarioActual']),
        documentacion: function () {
            let documentosAprobados = 0;

            for (let x = 0; x < this.usuarioActual.documentos_set.documentos_items.length; x++) {
                const documento = this.usuarioActual.documentos_set.documentos_items[x].documento;
                if (documento.cargado && documento.cargado.estado === 1) {
                    documentosAprobados++
                }
            }

            return `${documentosAprobados}/${this.usuarioActual.documentos_set.documentos_items.length}`;
        },
        documentacionCompleta: function () {
            const documentosDatos = this.documentacion.split('/');
            return documentosDatos[0] === documentosDatos[1];
        },
        documentacionStatus: function () {
            if (this.documentacionCompleta && this.documentacionCompleta === true) {
                return 'No hay documentos pendientes!!';
            } else {
                return 'Por favor complete la documentación!';
            }
        },
    },
    methods: {
        async procesarStats() {
            this.chequeando = true

            await this.$store.dispatch('auth/obtenerDatos');

            this.usuarios = (await UsuariosService.get({ first: 0, rows: 5000, sortField: 'id', sortOrder: 1, filters: '', nivel: 6, full_info: true })).usuarios.filter(
                (usuario) => usuario.nombre !== '',
            )

            this.usuariosActivos = this.usuarios.filter(usuario => {

                let activo = true;

                for (let x = 0; x < usuario.documentos_set.documentos_items.length; x++) {
                    const documento = usuario.documentos_set.documentos_items[x].documento;
                    if (!documento.cargado || documento.cargado.estado !== 1) {
                        activo = false;
                        break;
                    }
                }

                return activo;
            }).length;

            this.usuariosInactivos = this.usuarios.length - this.usuariosActivos;

            this.ultimoChequeoHora = moment().format('HH:mm:ss')

            this.chequeando = false
        },
    }
};
</script>

<style lang="scss" scoped>
.cargandoSpinner {
    width: 18px;
    height: 18px;
}

.chequeosStatusBar {
    width: 100%;
    height: 36px;
    line-height: 36px;
    margin-top: 0;
    margin-bottom: 30px;
    background-color: #e6e6e6;
    border-bottom: 1px solid #666;
    z-index: 1;
    text-align: left;
    padding-left: 16px;
}
.chequeandoSpinner {
    width: 18px;
    height: 18px;
    margin-left: 10px;
}
.chequeandoAviso {
    font-size: 12px;
    line-height: 20px;
    margin-left: 5px;
    vertical-align: 2px;
    display: inline-block;
}

.ultimoChequeoHora {
    color: #666;
}

.detail {
    padding-right: 60px;
}

.title.link {
    text-decoration: underline;
    cursor: pointer;
}
</style>
